import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "15",
  fill: "none",
  viewBox: "0 0 15 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "#032E32",
        d: "M13.7.3a1.01 1.01 0 0 0-.996-.262L.814 3.388a1.028 1.028 0 0 0-.167 1.907l5.47 2.583 2.585 5.467a1.02 1.02 0 0 0 .92.58h.088a1.015 1.015 0 0 0 .9-.74l3.351-11.89A1.01 1.01 0 0 0 13.7.3M9.626 12.905 7.113 7.604l2.636-2.635a.51.51 0 1 0-.721-.72L6.392 6.882 1.088 4.37l11.89-3.35z"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h14.745v14.745H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }